export const GameSceneType = {
  main: 'main',
  bonus: 'bonus',
};

export const GameMode = {
  demo: 'demo',
  real: 'real',
};

export const GameApplicationType = {
  mobile: 'mobile',
  web: 'web',
  landscape: 'landscape',
};

export const GameLayers = {
  background: 'background',
  shadow: 'shadow',
  dragonForceBack: 'dragonForceBack',
  dragonForce: 'dragonForce',
  waterfallSpine: 'waterfallSpine',
  waterSpine: 'waterSpine',
  wallSpine: 'wallSpine',
  fishSpine: 'fishSpine',
  treesSpine: 'treesSpine',
  plateSpine: 'plateSpine',
  bonusBoard: 'bonusBoard',
  dragonSoulSpine: 'dragonSoulSpine',
  dragonSpine: 'dragonSpine',
  breakingBallSpine: 'breakingBallSpine',
  particles: 'particles',
  allBallsBreakingSpine: 'allBallsBreakingSpine',
  balls: 'balls',
  ball: 'ball',
  gamePad: 'gamePad',
  footer: 'footer',
  buyBonusPopup: 'buyBonusPopup',
  congratulationsPopup: 'congratulationsPopup',
  bigWinPopup: 'bigWinPopup',
  winOdd: 'winOdd',
  buyBonusButton: 'buyBonusButton',
  deposit: 'deposit',
};


export const BallType = {
  yellow: 1,
  green: 2,
  pink: 3,
  magenta: 4,
  bonus: 5,
};

export const BallCrackType = {
  none: 0,
  state1: 1,
  state2: 2,
  state3: 3,
  state4: 4,
  max: 5,
};
export const ballSides = {
  right: 'rightBalls',
  left: 'leftBalls',
};

export const DragonBitingAnimation = {
  bonusBall: 'bonus_ball',
  break: 'break',
  crack: 'crack',
};

export const DragonSoulAnimations = {
  appear: 'appear',
  dracarys: 'dracarys',
  loop: 'loop',
};

export const WallAnimations = {
  wallLight: 'wall_light',
};

export const LeafAnimations = {
  animation: 'animation',
};

export const FishAnimations = {
  fish1: 'fish_1',
  fish2: 'fish_2',
  fish3: 'fish_3',
  fish4: 'fish_4',
};

export const TicketType = {
  green: 0,
  red: 1,
  blue: 2,
};

export const BigWinCoinsAnimation = {
  beginning: 'beginning',
  loop: 'loop',
};

export const BigWinWordAnimation = {
  bigEpicWin: 'big_epic_win',
  bigMaxWin: 'big_max_win',
  bigMegaWin: 'big_mega_win',
  bigSuperWin: 'big_super_win',
  bigWin: 'big_win',
};
